import {
    BaseLinkModel,
    BaseNodeModel,
    ConditionNodeModel,
    IntentDataModel,
    ModuleNodeModel,
    BannerNodeModel,
    BeginNodeModel,
    CustomNodeModel,
    DataAccessCompletionNodeModel,
    DataNodeModel,
    DialogManagerNodeModel,
    DtmfNodeModel,
    ExitNodeModel,
    FlushPromptsNodeModel,
    InputNodeModel,
    LoopEscalationNodeModel,
    ModuleReferenceNodeModel,
    NoteNodeModel,
    PlaySavedPromptNodeModel,
    PromptNodeModel,
    PromptReferenceNodeModel,
    ReportBillingNodeModel,
    ReportNodeModel,
    RichTextNodeModel,
    SavePromptNodeModel,
    SessionCompletionNodeModel,
    SessionNodeModel,
    TabNodeModel,
    TaskOrchestrationNodeModel,
    WithFillerNodeModel
} from "../models";
// Registry for dynamic node instantiation
// !!! Dont forget to add reserved name to webpack prod config !!!
// Set `props.iconClass` on models that extend `BaseNodeModel` and add the rest to `getModelIcon`.
// Update updateParentNode function in AppManager
const register = {
    BannerNodeModel,
    BaseLinkModel,
    BaseNodeModel,
    BeginNodeModel,
    ConditionNodeModel,
    CustomNodeModel,
    DataAccessCompletionNodeModel,
    DataNodeModel,
    DialogManagerNodeModel,
    DtmfNodeModel,
    ExitNodeModel,
    FlushPromptsNodeModel,
    InputNodeModel,
    IntentDataModel,
    LoopEscalationNodeModel,
    ModuleNodeModel,
    ModuleReferenceNodeModel,
    NoteNodeModel,
    PlaySavedPromptNodeModel,
    PromptNodeModel,
    PromptReferenceNodeModel,
    ReportBillingNodeModel,
    ReportNodeModel,
    RichTextNodeModel,
    SavePromptNodeModel,
    SessionCompletionNodeModel,
    SessionNodeModel,
    TabNodeModel,
    TaskOrchestrationNodeModel,
    // Backward compatibility between VXMLRenderNodeModel <-> FlushPromptsNodeModel
    VXMLRenderNodeModel: FlushPromptsNodeModel,
    WithFillerNodeModel
};

const registerNodeTypeName = {
    "Banner Message": BannerNodeModel,
    "Blank Object": BaseNodeModel,
    "Condition": ConditionNodeModel,
    "Custom Script": CustomNodeModel,
    "Data Access Completion": DataAccessCompletionNodeModel,
    "Data Access": DataNodeModel,
    "Dialog Manager": DialogManagerNodeModel,
    "Dtmf Menu": DtmfNodeModel,
    "Flush Prompts": FlushPromptsNodeModel,
    "Input": InputNodeModel,
    "Intent": IntentDataModel,
    "Loop Escalation": LoopEscalationNodeModel,
    "Module Begin": BeginNodeModel,
    "Module Exit": ExitNodeModel,
    "Module Reference": ModuleReferenceNodeModel,
    "Module": ModuleNodeModel,
    "Note": NoteNodeModel,
    "Play Saved Prompt": PlaySavedPromptNodeModel,
    "Prompt Reference": PromptReferenceNodeModel,
    "Prompt": PromptNodeModel,
    "Report Billing Tag": ReportBillingNodeModel,
    "Report Tag": ReportNodeModel,
    "Rich Text": RichTextNodeModel,
    "Save Prompt": SavePromptNodeModel,
    "Session Completion": SessionCompletionNodeModel,
    "Session": SessionNodeModel,
    "Tabular Router": TabNodeModel,
    "Task Orchestration": TaskOrchestrationNodeModel,
    "Transition": BaseLinkModel,
    "With Filler": WithFillerNodeModel
};

export default class NodeRegistry {

    /**
     * Node dynamic instantiation
     * @module NodeRegistry
     */
    static get r() {
        return register;
    }

    /**
     * Node dynamic instantiation
     * @module NodeRegistry
     */
    static get rn() {
        return registerNodeTypeName;
    }

    /**
     * Construct a new Node using NodeRegistry
     * @param target
     * @param source
     */
    static buildNode(element) {
        if (register.hasOwnProperty(element._class)) {
            return new NodeRegistry.r[element._class](element.name, element.x, element.y, element.props, element.id);
        } else {
            return new NodeRegistry.rn[element.props.nodeTypeName](element.name, element.x, element.y, element.props, element.id);
        }
    }
}
